import { useTranslation } from 'react-i18next';

export default function ErrorMessage({ 
  error, 
  onRetry = null, 
  className = '',
  showDetails = false 
}) {
  const { t } = useTranslation();
  
  if (!error) return null;
  
  return (
    <div className={`bg-red-50 border border-red-200 rounded-lg p-4 ${className}`}>
      <div className="flex items-start">
        <div className="text-red-600 text-xl mr-3">⚠️</div>
        <div className="flex-1">
          <h3 className="text-red-800 font-medium mb-2">
            {t('error.error_occurred')}
          </h3>
          <p className="text-red-700 text-sm mb-3">
            {error.message || error}
          </p>
          
          {showDetails && error.stack && (
            <details className="text-xs text-red-600 mb-3">
              <summary className="cursor-pointer">
                {t('error.show_details')}
              </summary>
              <pre className="mt-2 whitespace-pre-wrap bg-red-100 p-2 rounded">
                {error.stack}
              </pre>
            </details>
          )}
          
          {onRetry && (
            <button
              onClick={onRetry}
              className="text-red-800 underline hover:no-underline text-sm"
            >
              {t('error.try_again')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
